import * as React from "react";
const SvgAlert = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 142.875 130.533", height: 493.353, width: 540, ...props }, /* @__PURE__ */ React.createElement("path", { style: {
  color: "#000",
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: 400,
  fontStretch: "normal",
  fontSize: "medium",
  lineHeight: "normal",
  fontFamily: "sans-serif",
  fontVariantLigatures: "normal",
  fontVariantPosition: "normal",
  fontVariantCaps: "normal",
  fontVariantNumeric: "normal",
  fontVariantAlternates: "normal",
  fontFeatureSettings: "normal",
  textIndent: 0,
  textAlign: "start",
  textDecoration: "none",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textDecorationColor: "#000",
  letterSpacing: "normal",
  wordSpacing: "normal",
  textTransform: "none",
  writingMode: "lr-tb",
  direction: "ltr",
  textOrientation: "mixed",
  dominantBaseline: "auto",
  baselineShift: "baseline",
  textAnchor: "start",
  whiteSpace: "normal",
  shapePadding: 0,
  clipRule: "nonzero",
  display: "inline",
  overflow: "visible",
  visibility: "visible",
  opacity: 1,
  isolation: "auto",
  mixBlendMode: "normal",
  colorInterpolation: "sRGB",
  colorInterpolationFilters: "linearRGB",
  solidColor: "#000",
  solidOpacity: 1,
  vectorEffect: "none",
  fill: "#d0d5dc",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 23.77096939,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1,
  colorRendering: "auto",
  imageRendering: "auto",
  shapeRendering: "auto",
  textRendering: "auto",
  enableBackground: "accumulate"
}, d: "M71.732 166.469c-8.765-.104-16.989 4.553-21.392 12.18L3.105 260.455c-9.088 15.748 2.92 36.542 21.102 36.544h94.466c18.178-.01 30.182-20.798 21.095-36.544l-47.232-81.808a24.403 24.403 0 0 0-19.954-12.155 26.84 26.84 0 0 0-.85-.025zm-.132 10.886c.157 0 .313.01.47.014a13.483 13.483 0 0 1 11.04 6.723l47.232 81.808c5.161 8.942-1.346 20.21-11.67 20.213H24.205c-10.325 0-16.832-11.27-11.67-20.213l47.233-81.808a13.481 13.481 0 0 1 11.832-6.737z", transform: "translate(0 -166.467)" }), /* @__PURE__ */ React.createElement("path", { style: {
  color: "#000",
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: 400,
  fontStretch: "normal",
  fontSize: "medium",
  lineHeight: "normal",
  fontFamily: "sans-serif",
  fontVariantLigatures: "normal",
  fontVariantPosition: "normal",
  fontVariantCaps: "normal",
  fontVariantNumeric: "normal",
  fontVariantAlternates: "normal",
  fontFeatureSettings: "normal",
  textIndent: 0,
  textAlign: "start",
  textDecoration: "none",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textDecorationColor: "#000",
  letterSpacing: "normal",
  wordSpacing: "normal",
  textTransform: "none",
  writingMode: "lr-tb",
  direction: "ltr",
  textOrientation: "mixed",
  dominantBaseline: "auto",
  baselineShift: "baseline",
  textAnchor: "start",
  whiteSpace: "normal",
  shapePadding: 0,
  clipRule: "nonzero",
  display: "inline",
  overflow: "visible",
  visibility: "visible",
  opacity: 1,
  isolation: "auto",
  mixBlendMode: "normal",
  colorInterpolation: "sRGB",
  colorInterpolationFilters: "linearRGB",
  solidColor: "#000",
  solidOpacity: 1,
  vectorEffect: "none",
  fill: "none",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "#546072",
  strokeWidth: 1.99999976,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1,
  colorRendering: "auto",
  imageRendering: "auto",
  shapeRendering: "auto",
  textRendering: "auto",
  enableBackground: "accumulate"
}, d: "M71.99 178.204a12.501 12.501 0 0 0-11.413 6.236l-47.316 81.952c-4.81 8.333 1.204 18.749 10.826 18.75h94.63c9.622 0 15.634-10.417 10.825-18.75L82.228 184.44a12.501 12.501 0 0 0-10.239-6.236z", transform: "translate(0 -166.467)" }), /* @__PURE__ */ React.createElement("g", { style: {
  fill: "#d5332e",
  fillOpacity: 1
} }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  fill: "#d5332e",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 96.63084412,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, d: "M217.928 228.404c-5.115.232-10.316 2.424-14.412 6.52-8.192 8.192-8.763 20.81-1.28 28.293l39.211 39.213-39.21 39.21c-7.484 7.484-6.913 20.104 1.279 28.296s20.811 8.764 28.295 1.28l39.212-39.212 39.211 39.213c7.483 7.483 20.103 6.91 28.295-1.281 8.192-8.193 8.763-20.81 1.28-28.293l-39.213-39.213 39.213-39.213c7.483-7.483 6.912-20.101-1.28-28.293s-20.812-8.765-28.295-1.281l-39.213 39.212-39.21-39.212c-3.742-3.742-8.769-5.47-13.883-5.239z", transform: "matrix(.26458 0 0 .26458 0 0)" })));
export default SvgAlert;
